import { c as _c } from "react/compiler-runtime";
import { useFormatTranslationString } from '@shared/utils/helpers/format-translation-string';
import { getMembershipInformation } from '../../helpers/get-membership-information';
import { type ApplicationDefinition } from '../../types/application-definition';
import { type CustomerProfile } from '../../types/customer-profile';
import { type MembershipApplicationDto } from '../../types/membership-application';
import { getInformationChipData, type InformationChipCMSContent } from './utils/helpers';
export const useInformationChipProps = t0 => {
  const $ = _c(8);
  const {
    applicationDefinition,
    cmsContent,
    customerProfile,
    handleUpgradeMembershipClick,
    membershipApplication,
    membershipApplicationUrl
  } = t0;
  const formatTranslationString = useFormatTranslationString();
  let t1;
  if ($[0] !== applicationDefinition || $[1] !== cmsContent || $[2] !== customerProfile || $[3] !== formatTranslationString || $[4] !== handleUpgradeMembershipClick || $[5] !== membershipApplication || $[6] !== membershipApplicationUrl) {
    const {
      isApplicationInReview,
      isApplicationUnfinished,
      isCurrentMember,
      isLessThanTenDaysLeftUntilLateFees,
      isLessThanThirtyDaysLeftUntilLateFees,
      isMemberAbleToUpgrade,
      isNewUser,
      isPreviousButNotCurrentMember,
      isThirtyToTenDaysLeftUntilLateFees,
      isUpgrading,
      subtractCurrentDateFromLateFeeStartDate
    } = getMembershipInformation({
      applicationDefinition,
      customerProfile,
      membershipApplication
    });
    t1 = getInformationChipData({
      cmsContent: {
        ...cmsContent,
        numberOfDaysLeft: formatTranslationString(cmsContent.numberOfDaysLeft, {
          daysLeft: subtractCurrentDateFromLateFeeStartDate && Math.round(subtractCurrentDateFromLateFeeStartDate)
        })
      },
      handleUpgradeMembershipClick,
      isApplicationInReview,
      isApplicationUnfinished,
      isCurrentMember,
      isLessThanTenDaysLeftUntilLateFees,
      isLessThanThirtyDaysLeftUntilLateFees,
      isMemberAbleToUpgrade,
      isNewUser,
      isPreviousButNotCurrentMember,
      isThirtyToTenDaysLeftUntilLateFees,
      isUpgrading,
      membershipApplicationUrl
    });
    $[0] = applicationDefinition;
    $[1] = cmsContent;
    $[2] = customerProfile;
    $[3] = formatTranslationString;
    $[4] = handleUpgradeMembershipClick;
    $[5] = membershipApplication;
    $[6] = membershipApplicationUrl;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
};